module.exports = __webpack_public_path__ + "img/rock-bg.99696f20.jpg";